module.exports = __webpack_public_path__ + "Roboto-Bold.21c028aef98fadd879a3.woff";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Bold.woff
// module id = ../../../../../src/assets/fonts/Roboto-Bold.woff
// module chunks = styles